const defaultConfig = {
  verbose: true,
}

const methodNames = [
  'debug',
  'info',
  'warning',
  'error',
  'critical',
]

const methodToConsoleMap = {
  debug: 'debug',
  info: 'info',
  warning: 'warn',
  error: 'error',
  critical: 'error',
}

const missingMethodWarning = (methodName) => {
  console.warn(`Logger Warning: Missing adapter method \`${methodName}\``)
}

const makeMethod = (config, adapter, methodName) => {
    const consoleMethod = methodToConsoleMap[methodName]

    return (...params) => {
      if (config.verbose) console[consoleMethod]('Logger:', ...params)
      if (adapter?.[methodName] === undefined) {
        missingMethodWarning(methodName)
      } else {
        adapter[methodName](...params)
      }
    }
  }

const Log = () => {
  let config = defaultConfig
  let adapter = undefined

  const methods = methodNames.reduce((acc, methodName) => {
    return {
      ...acc,
      [methodName]: makeMethod(config, adapter, methodName)
    }
  }, {})

  return {
    config,
    adapter,
    ...methods
  }
}

export default Log()
